import { render } from "./NRating.vue?vue&type=template&id=49238ddc"
import script from "./NRating.vue?vue&type=script&lang=js"
export * from "./NRating.vue?vue&type=script&lang=js"

import "./NRating.vue?vue&type=style&index=0&id=49238ddc&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__